/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const ourValuesStyle = {
  image: (theme: Theme) => ({
    maxWidth: "100%",
    height: "auto",
    marginTop: "1.5rem",
    borderRadius: "0.5rem",
    [theme.breakpoints.up("md")]: {
      marginTop: "6em",
    },
  }),
};
